module.exports = __webpack_public_path__ + "static/media/pregnancyAppLogo.92f15903.png";